import { Controller } from '@hotwired/stimulus';

// The /localleads hero sheet: clicking a sheet tab shows that search's results.
// Every list is server-rendered; without JS the first one shows and the rest stay hidden.
export default class extends Controller {
  static targets = ['tab', 'panel'];

  show(event) {
    this.select(Number(event.currentTarget.dataset.index));
  }

  // Arrow keys move between tabs, as in a normal tablist.
  key(event) {
    const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
    if (!step) return;
    event.preventDefault();
    const count = this.tabTargets.length;
    const index = (this.current() + step + count) % count;
    this.select(index);
    this.tabTargets[index].focus();
  }

  current() {
    return this.tabTargets.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
  }

  select(index) {
    this.tabTargets.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panelTargets.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }
}
